export default {
  title:       'Gestão do consentimento',
  description: 'Eliminação dos dados pessoais tratados com o consentimento do titular',
  disclaimer:  'De acordo com as <a href="/politica_de_privacidade" target="_blank">políticas de retenção de dados</a>, iremos manter os dados pelo prazo exigido na legislação aplicável para o exercício regular de nossos direitos',
};
